"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_DISPLAY_INVENTORY = void 0;
var client_1 = require("@apollo/client");
var fragments_1 = require("../fragments");
exports.GET_DISPLAY_INVENTORY = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetDisplayInventory($displayId: ID!) {\n    displayInventory(displayId: $displayId) {\n      ...SimpleInventory\n    }\n  }\n  ", "\n"], ["\n  query GetDisplayInventory($displayId: ID!) {\n    displayInventory(displayId: $displayId) {\n      ...SimpleInventory\n    }\n  }\n  ", "\n"])), fragments_1.SIMPLE_INVENTORY_FRAGMENT);
var templateObject_1;
